import React, { Component } from 'react';
import PaymentItemCard from './PaymentItemCard';
import './SpaPayment.css';
import { confirmAlert } from 'react-confirm-alert';
import PaymentForm from './PaymentForm.js';
import FocusLock from 'react-focus-lock';

import paypalImg from '../../images/pay-with-paypal.png';


class SpaPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payType: '',
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.handleRadioKeyUp = this.handleRadioKeyUp.bind(this);
    }

    componentDidMount() {
        this.props.setPayer({});
    }

    selectGuestPayer=(guest)=> {
        if (guest === 'Not_in_booking') {
            this.props.selectGuestPayer(false);
            return;
        }
        this.props.selectGuestPayer(guest);
    }

    get CartItems() {
        let { cart = [], daysToCruise } = this.props;
        if (cart && cart.length > 0) {
            return cart.map((item) => (
                <PaymentItemCard
                    daysToCruise={daysToCruise}
                    openDetailsPage={this.props.openDetailsPage}
                    ShipboardCurrencyCode={this.props.ShipboardCurrencyCode}
                    handleShowCancelPopup={this.handleShowCancelPopup.bind(this, item)}
                    item={item}
                />
            ));
        }
        return null;
    }

    handleInputChange(event) {
        let { payer = {} } = this.props;
        payer[event.target.name] = event.target.value;
        this.props.setPayer(payer);
    }

    handleRadioChange(event) {
        let { payer = {} } = this.props;
        //initHostedSession(_paymentAuthentication);
        payer.paymentType = event.target.name;
        payer.isCardHoldSelected = false;
        this.setState({ payType: event.target.name });
        this.props.setPayer(payer);
    }

    handleShowCancelPopup(reservedService) {
        //window.scrollTo(0, this.props.payRef.offsetTop+ 150);
        this.setState({}, () => {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div>
                            <div
                                className="spa-popup-custom-ui"
                                data-test-id="payment-pop-up-window">
                                <p
                                    role="alert"
                                    className="gotham-xn-book font-size-p02"
                                    data-test-id="cancel-text">
                                    Are you sure you wish to cancel: {reservedService.treatmentDesc}
                                </p>
                                <FocusLock>
                                    <button
                                        className="button gotham-xn-medium primary-btn font-size-p5 spa-popup-button"
                                        data-test-id="payment-cancel-yes"
                                        onClick={() => {
                                            this.cancelCartItem(reservedService);
                                            onClose();
                                        }}>
                                        Yes
                                    </button>
                                    <button
                                        className="button gotham-xn-medium secondary-btn font-size-p5 spa-popup-button"
                                        data-test-id="payment-cancel-no"
                                        onClick={() => {
                                            onClose();
                                        }}>
                                        No
                                    </button>
                                </FocusLock>
                            </div>
                        </div>
                    );
                },
            });
        });
    }

    cancelCartItem(cancelCartItem) {
        this.props.cancelCartItem(cancelCartItem);
    }

    handlePayPalPayment=(parms)=> {
        this.props.handlePayPalPayment(parms);
    }

    handleRadioKeyUp(e) {
        e.keyCode === 13 && this.handleRadioChange(e);
    }

    render() {
        let { guestDetails = [], payer = {}, isPayLoading } = this.props;
        let { cart = [] } = this.props;
        let { authDetails } = this.props.services;
        let cartPrice =
            !cart || cart.length === 0
                ? 0
                : cart.reduce((sum, cartItem) => sum + cartItem.treatmentPrice, 0);
        return (
            <div id="paymentform" className="reserveItem">
                <ul className="payment-cart-item spa-res-list list-style">{this.CartItems}</ul>
                <section id="forms" className={authDetails.appTrigger === 'POLAR' ? '' : ''}>
                    <div>
                        <fieldset className="fieldset-block">
                            <legend className="visuallyhidden">Make a Payment</legend>
                            <div className="row">
                                <h3
                                    style={{ marginTop: '0' }}
                                    className="col-sm-9 col-sm-pad-10 font-size-p8 gotham-xn-medium"
                                    data-test-id="make-payment">
                                    Make a Payment
                                </h3>
                                <span
                                    className="col-sm-3 font-size-p0 gotham-book required"
                                    data-test-id="required"
                                    id="starTitle">
                                    * Required
                                </span>
                            </div>

                            <div className="row form-field font-size-p0 gotham-book">
                                <div aria-label="Select Payment Type">
                                    <div
                                        data-test-id="credit-card-radio"
                                        className={
                                            payer.paymentType === 'credit-card'
                                                ? 'payment-selected-radio paymentTypeWidth pay-option-box float-left'
                                                : 'paymentTypeWidth pay-option-box float-left'
                                        }>
                                        <span
                                            name="credit-card"
                                            onKeyUp={this.handleRadioKeyUp}
                                            className="form-field radio paymentTypePaddingAdjust">
                                            <input
                                                className="outline-none"
                                                onChange={this.handleRadioChange}
                                                checked={payer.paymentType === 'credit-card'}
                                                type="radio"
                                                name="credit-card"
                                                id="creditcard_radio"
                                            />
                                            <label
                                                className={
                                                    payer.paymentType === 'credit-card'
                                                        ? 'payment-selected-label payPalFont'
                                                        : 'payPalFont'
                                                }
                                                htmlFor="creditcard_radio">
                                                Credit Card
                                            </label>
                                        </span>
                                    </div>

                                    <div
                                        data-test-id="paypal-radio"
                                        className={
                                            payer.paymentType === 'pay-pal'
                                                ? 'payment-selected-radio paymentTypeWidth pay-option-box float-left'
                                                : 'paymentTypeWidth pay-option-box float-left'
                                        }>
                                        <span
                                            name="pay-pal"
                                            onKeyUp={this.handleRadioKeyUp}
                                            className="form-field radio paymentTypePaddingAdjust">
                                            <input
                                                className="outline-none"
                                                type="radio"
                                                checked={payer.paymentType === 'pay-pal'}
                                                onChange={this.handleRadioChange}
                                                name="pay-pal"
                                                id="paypal_radio"
                                            />
                                            <label
                                                className={
                                                    payer.paymentType === 'pay-pal'
                                                        ? 'payment-selected-label payPalFont'
                                                        : 'payPalFont'
                                                }
                                                htmlFor="paypal_radio">
                                                PayPal
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-3"></div>
                            {this.state.payType && payer.paymentType === 'credit-card' && (
                                <div className="col-sm-9 font-size-p0 gotham-book">
                                    <PaymentForm
                                        ShipboardCurrencyCode={this.props.ShipboardCurrencyCode}
                                        setPayer={this.props.setPayer}
                                        selectGuestPayer={this.selectGuestPayer}
                                        guestDetails={guestDetails}
                                        cartPrice={cartPrice}
                                        isPayLoading={isPayLoading}
                                        handlePayment={this.props.handlePayment}
                                        handleInputChange={this.handleInputChange}
                                        payer={payer}
                                    />
                                </div>
                            )}
                            {payer.paymentType === 'pay-pal' && (
                                <>
                                    <div className="row form-field">
                                        <span className="font-size-p5 gotham-xn-medium">
                                            Total Balance Due:{' '}
                                            <sup className="balance-due">{`${
                                                this.props.ShipboardCurrencyCode === 'USD'
                                                    ? '$'
                                                    : 'AU$'
                                                } `}</sup>
                                            {` ${cartPrice}`}{' '}
                                        </span>
                                    </div>
                                    <div>
                                        <p class="font-weight-700 col-sm-pad-10">Proceeding will take you to the Paypal site to pay for your order. Paypal payments will incur a 1% surcharge.</p>
                                        <button
                                            className="pay-pal-button"
                                            onClick={this.handlePayPalPayment}
                                            title="PayPal  Payment">
                                            <img
                                                src={paypalImg}
                                                width="100px"
                                                height="40px"
                                                alt="Pay with Paypal"
                                            />
                                        </button>
                                    </div>
                                </>
                            )}
                        </fieldset>
                    </div>
                </section>
            </div>
        );
    }
}

export default SpaPayment;
